var _clipPath, _clipPath2, _clipPath3, _tspan, _tspan2, _tspan3, _tspan4, _tspan5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 232.844,
    height: 71.054,
    viewBox: "0 0 61.607 18.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M152.4 470.463h273.397l5.208-88.528-275.133-2.604z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: ".82973498px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    }
  })), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "b",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 841.89h595.28V0H0Z"
  }))), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "c",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M229.403 413.35h188.725v29.032H229.403Z"
  }))), _clipPath3 || (_clipPath3 = /*#__PURE__*/React.createElement("clipPath", {
    id: "d",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 841.89h595.28V0H0Z"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    style: {
      opacity: 1
    },
    transform: "matrix(.25503 0 0 -.25503 -45.028 115.54)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M177.178 413.8c9.294 4.785 22.908 12.52 39.068 23.83v3.795c-14.222-9.304-28.685-16.776-39.068-21.719zM177.178 425.135c10.348 4.217 24.812 10.729 39.068 19.209v1.874c-13.399-6.647-27.321-10.808-39.068-13.401zM216.247 413.782v19.092c-8.895-7.498-17.704-13.99-25.103-19.092zM186.148 413.782c7.026 4.17 15.556 9.614 24.049 15.976a509.95 509.95 0 0 1 6.05 4.596v2.366c-12.572-9.425-25.403-17.282-35.427-22.938zM177.178 435.594c11.427 2.01 25.407 5.625 39.068 12.117v2.129c-13.766-6.18-27.546-8.801-39.068-9.733z",
    style: {
      fill: "#00927b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.178 453.047v-10.938c.854.054 1.724.115 2.612.183 9.5.731 22.465 2.409 36.456 8.459v2.296z",
    style: {
      fill: "#00927b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.178 442.11v-2.003c11.522.933 25.302 3.554 39.068 9.733v.912c-13.991-6.05-26.956-7.729-36.456-8.459-.888-.07-1.758-.13-2.612-.183M177.178 432.817c11.747 2.594 25.669 6.754 39.068 13.401v1.494c-13.661-6.493-27.641-10.108-39.068-12.118zM177.178 419.706c10.383 4.943 24.846 12.415 39.068 21.719v2.919c-14.256-8.479-28.72-14.993-39.068-19.209zM186.148 413.782h4.996c7.4 5.102 16.208 11.594 25.103 19.092v1.48a509.95 509.95 0 0 0-6.05-4.596c-8.493-6.362-17.023-11.806-24.049-15.976M177.178 413.782h3.642c10.024 5.656 22.855 13.513 35.426 22.938v.909c-16.16-11.309-29.774-19.044-39.068-23.829Z",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M229.403 413.8h5.251v11.48h8.852v4.126h-8.852v6.449h9.302v4.125h-14.553zm18.152 0h5.026v7.091c0 2.774 0 7.877 4.087 7.877.9 0 1.8-.148 2.252-.413v5.063c-.526.15-1.05.15-1.538.15-3 0-5.064-3.04-5.289-4.836h-.075v4.385h-4.463zm15.115 13.991c1.687 1.277 3.824 2.101 5.963 2.101 2.961 0 4.35-1.05 4.35-4.164h-2.775c-2.1 0-4.576-.184-6.489-1.124-1.913-.939-3.298-2.626-3.298-5.516 0-3.673 3.336-5.737 6.749-5.737 2.288 0 4.801 1.199 5.962 3.337h.077c.039-.597.039-1.871.224-2.888h4.425a89.398 89.398 0 0 0-.226 4.316 172.14 172.14 0 0 0-.074 4.839v2.475c0 5.702-2.437 8.138-8.325 8.138-2.139 0-4.763-.564-6.714-1.464zm2.548-8.401c0 2.964 3.338 3.339 5.589 3.339h2.176c0-1.502-.225-2.886-1.052-3.978-.787-1.045-1.985-1.727-3.523-1.727-1.8 0-3.19.717-3.19 2.366m34.283 13.727h-5.029v-9.452c0-2.473-.787-6.412-4.424-6.412-3.226 0-3.263 3.189-3.263 5.552v10.312h-5.026v-12.19c0-4.35 1.989-7.576 6.564-7.576 2.624 0 4.801 1.199 6.338 3.076h.076V413.8h4.764zm5.178-19.317h5.023v9.455c0 2.473.789 6.414 4.426 6.414 3.224 0 3.262-3.19 3.262-5.552V413.8h5.029v12.192c0 4.35-1.99 7.576-6.565 7.576-2.625 0-4.765-.864-6.337-3.076h-.08v2.625h-4.758zm22.912 0h5.026v9.455c0 2.473.787 6.414 4.428 6.414 3.225 0 3.261-3.19 3.261-5.552V413.8h5.021v12.192c0 4.35-1.986 7.576-6.558 7.576-2.625 0-4.802-1.201-6.072-3.076h-.08v11.438h-5.026zm20.926 9.527c0-5.547 3.716-9.976 10.092-9.976 6.412 0 10.124 4.429 10.124 9.976 0 6.378-4.383 10.241-10.124 10.241-5.701 0-10.092-3.863-10.092-10.241m5.253.603c0 2.888 1.574 5.739 4.839 5.739 3.301 0 4.874-2.777 4.874-5.739 0-3.227-1.009-6.677-4.874-6.677-3.83 0-4.839 3.489-4.839 6.677m19.989-10.13h5.024v15.643h4.388v3.674h-4.388v2.401c0 1.499.528 2.964 2.218 2.964 1.085 0 1.724-.414 2.17-.678l.414 4.164c-.975.225-2.398.414-3.674.414-3.977 0-6.152-2.701-6.152-6.564v-2.701h-3.711v-3.674h3.711zm16.051 11.554c.229 2.588 1.65 4.538 4.463 4.538 2.816 0 3.942-2.101 4.087-4.538zm11.928-6.378c-1.878-1.049-3.974-1.952-6.416-1.952-3.107 0-5.283 1.763-5.512 4.881h13.35c0 6.751-2.023 11.663-9.188 11.663-5.997 0-8.96-4.612-8.96-10.201 0-6.343 3.71-10.016 10.089-10.016 2.702 0 4.796.525 6.637 1.539zm5.027-5.176h5.024v7.091c0 2.774 0 7.877 4.085 7.877.902 0 1.804-.148 2.254-.413v5.063c-.53.15-1.053.15-1.54.15-2.999 0-5.062-3.04-5.286-4.836h-.077v4.385h-4.46z",
    style: {
      fill: "#1a171b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M394.282 400.464h7.034v-2.065h-4.496v-3.228h4.28v-2.063h-4.28v-5.742h-2.538z",
    style: {
      fill: "#1a171b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.215 387.366v13.098",
    style: {
      fill: "none",
      stroke: "#1a171b",
      strokeWidth: 2.53800011,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.962 398.399h-3.626v2.065h9.792v-2.065H414.5v-11.033h-2.538z",
    style: {
      fill: "#1a171b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  })), /*#__PURE__*/React.createElement("text", {
    style: {
      fontVariant: "normal",
      fontWeight: 400,
      fontStretch: "normal",
      fontSize: "24.75px",
      fontFamily: "&quot",
      InkscapeFontSpecification: "TrebuchetMS",
      writingMode: "lr-tb",
      fill: "#1a171b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1 0 0 -1 176.403 341.366)"
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "P"))), /*#__PURE__*/React.createElement("text", {
    style: {
      fontVariant: "normal",
      fontWeight: 400,
      fontStretch: "normal",
      fontSize: "24.75px",
      fontFamily: "&quot",
      InkscapeFontSpecification: "TrebuchetMS",
      writingMode: "lr-tb",
      fill: "#1a171b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1 0 0 -1 190.204 341.366)"
  }, _tspan2 || (_tspan2 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "r"))), /*#__PURE__*/React.createElement("text", {
    style: {
      fontVariant: "normal",
      fontWeight: 400,
      fontStretch: "normal",
      fontSize: "24.75px",
      fontFamily: "&quot",
      InkscapeFontSpecification: "TrebuchetMS",
      writingMode: "lr-tb",
      fill: "#1a171b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1 0 0 -1 199.378 341.366)"
  }, _tspan3 || (_tspan3 = /*#__PURE__*/React.createElement("tspan", {
    x: "0 13.29075 22.374001 35.862751 48.33675 58.137749 70.562248 80.190002 93.703499 107.48925 121.275 134.76375",
    y: 0
  }, "ojektgruppe"))), /*#__PURE__*/React.createElement("text", {
    style: {
      fontVariant: "normal",
      fontWeight: 400,
      fontStretch: "normal",
      fontSize: "24.75px",
      fontFamily: "&quot",
      InkscapeFontSpecification: "TrebuchetMS",
      writingMode: "lr-tb",
      fill: "#1a171b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1 0 0 -1 176.403 311.666)"
  }, _tspan4 || (_tspan4 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "W"))), /*#__PURE__*/React.createElement("text", {
    style: {
      fontVariant: "normal",
      fontWeight: 400,
      fontStretch: "normal",
      fontSize: "24.75px",
      fontFamily: "&quot",
      InkscapeFontSpecification: "TrebuchetMS",
      writingMode: "lr-tb",
      fill: "#1a171b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1 0 0 -1 198.085 311.666)"
  }, _tspan5 || (_tspan5 = /*#__PURE__*/React.createElement("tspan", {
    x: "0 7.05375 16.681499 26.4825 36.506248 48.7575 62.271 75.264748 84.422249 94.223251 104.247 111.30075 124.81425 133.97176 147.2625 156.89024 177.43275 190.4265 200.22749 207.28125",
    y: 0
  }, "irtschaftsinformatik")))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFit);
export default __webpack_public_path__ + "static/media/FIT.d2d261ecf51375103ee0d195063785a6.svg";
export { ForwardRef as ReactComponent };